/**
 * conversationVoice — la part pure du lecteur des vocaux : où en est la lecture, sa vitesse, et
 * l'extension du fichier copié en cache (`remoteAudioExtension` d'`AudioRecordingContainer.js`). La
 * durée d'un vocal se dit par `voiceFormatter`.
 */

/** « 0:00 », « 1:05 » : où en est la lecture. Contrairement à la durée, le début s'écrit. */
export function formatVoiceElapsed(seconds: number | null | undefined): string {
    const total = seconds != null && Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0
    return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`
}

/** La vitesse suivante de l'ancien lecteur (`cycleRate`) : 1x → 1,5x → 2x → 1x. */
export function nextVoiceRate(rate: number): number {
    if (rate >= 2) return 1
    if (rate >= 1.5) return 2
    return 1.5
}

/** L'extension que l'adresse porte, `.m4a` quand elle n'en dit rien (celle de l'enregistreur de l'app). */
export function voiceExtension(uri: string): string {
    const match = /\.(m4a|mp4|mp3|wav|aac|caf|webm|ogg)(?:\?|#|$)/i.exec(uri)
    return match ? `.${match[1]!.toLowerCase()}` : ".m4a"
}
